export interface LimitedNotification {
  id: number;
  description: string;
  title: string;
  appName: string;
  personId: number;
  entity: string;
  profileImage: string | null;
  entityId: number;
  otherEntity: string | null;
  targetEvent: string | null;
  isRead: boolean;
  createdAt: string;
  redirectLink: string;
}

export interface LimitedNotificationResponseData {
  notifications: LimitedNotification[];
  unreadNotificationCount: number;
}

export interface LimitedNotificationResponse {
  data: LimitedNotificationResponseData;
  message: string;
}

export interface IFetchLimitedNotifications {
  data: LimitedNotificationResponseData;
  message: string;
  stateIs: "Idle" | "Pending" | "Error";
}

const initialLimitedNotificationsData: IFetchLimitedNotifications = {
  data: {
    notifications: [],
    unreadNotificationCount: 0,
  },
  message: "",
  stateIs: "Idle",
};

export default initialLimitedNotificationsData;
